import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/LanguageSwitcher.css';

const LANGS = [
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
];

/**
 * LanguageSwitcher — toggles between FR/EN.
 * Updates URL prefix (/en/...) and i18next language.
 * variant: "pill" (landing page) | "compact" (navbar/footer)
 */
export default function LanguageSwitcher({ variant = 'pill' }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const currentLang = i18n.language || 'fr';

  const switchLang = (lang) => {
    if (lang === currentLang) return;

    // Build new path
    const path = location.pathname;
    let newPath;

    if (lang === 'fr') {
      // Remove /en prefix → bare path (French is default)
      newPath = path.replace(/^\/en(\/|$)/, '/');
    } else {
      // Add /en prefix
      const bare = path.replace(/^\/en(\/|$)/, '/');
      newPath = `/en${bare === '/' ? '' : bare}`;
    }

    i18n.changeLanguage(lang);
    navigate(newPath + location.search + location.hash, { replace: true });
  };

  if (variant === 'compact') {
    return (
      <button
        className="lang-toggle-compact"
        onClick={() => switchLang(currentLang === 'fr' ? 'en' : 'fr')}
        aria-label={currentLang === 'fr' ? 'Switch to English' : 'Passer en français'}
        title={currentLang === 'fr' ? 'English' : 'Français'}
      >
        {currentLang === 'fr' ? '🇬🇧 EN' : '🇫🇷 FR'}
      </button>
    );
  }

  return (
    <div className="lang-switcher" role="radiogroup" aria-label="Language">
      {LANGS.map((lang) => (
        <button
          key={lang.code}
          className={`lang-btn ${currentLang === lang.code ? 'lang-active' : ''}`}
          onClick={() => switchLang(lang.code)}
          role="radio"
          aria-checked={currentLang === lang.code}
        >
          <span className="lang-flag">{lang.flag}</span>
          <span className="lang-label">{lang.label}</span>
        </button>
      ))}
    </div>
  );
}
